import { SxProps, useTheme } from '@mui/material';
import { IconButton } from '@portals/core/src/components/IconButton/IconButton';
import type { Theme } from '@portals/core/src/themes/themes';
import React, { MouseEventHandler, useCallback } from 'react';

import { getStyles } from './ActionButton.styles';

interface Props {
  sx?: SxProps<Theme>;
  icon: React.ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  size?: 'default' | 'small';
  ariaLabel?: string;
}

export const ActionButton: React.FunctionComponent<Props> = ({ onClick, icon, size = 'default', ...props }: Props) => {
  const theme = useTheme();
  const styles = getStyles(theme, size);

  const onMouseUp = useCallback((e) => {
    e.currentTarget.blur();
  }, []);

  return (
    <IconButton
      onClick={onClick}
      onMouseUp={onMouseUp}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      sx={{
        ...styles.button,
        ...props.sx,
      }}
      aria-label={props.ariaLabel}
    >
      {icon}
    </IconButton>
  );
};

ActionButton.displayName = 'ActionButton';
